import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Banner from "../../components/Banner/Banner";
import Features from "../../components/Features/Features";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import "./home.css";
import { popularsData } from "../../utils/data";
import PopularCard from "../../components/Cards/PopularCard";
import SafariSection from '../../components/SafariSection/SafariSection';
import HotelBookingForm from '../../components/HotelBookingForm/HotelBookingForm';

const Home = () => {
  const [showHotelModal, setShowHotelModal] = useState(false);

  // Filter out the first 4 packages (IDs 0-3)
  const filteredPopularData = popularsData.filter(tour => tour.id > 3);

  const PackagesSection = () => {
    return (
      <section className="packages-section" id="packages-section">
        <Container>
          <div className="packages-header text-center">
            <h2>Explore Our Packages</h2>
            <p>Choose from our carefully curated safari packages</p>
            <div style={{ marginBottom: '30px' }}>
              <div className="price-pill" style={{
                display: 'inline-block',
                backgroundColor: '#D4AF37',
                color: 'white',
                padding: '10px 25px',
                borderRadius: '30px',
                margin: '5px',
                fontSize: '1.1rem'
              }}>
                Packages starting from ₹14,000
              </div>
              <div className="price-pill" style={{
                display: 'inline-block',
                backgroundColor: '#D4AF37',
                color: 'white',
                padding: '10px 25px',
                borderRadius: '30px',
                margin: '5px',
                fontSize: '1.1rem'
              }}>
                 Customized tours available upon request
              </div>
            </div>
          </div>
          
          <Row className="g-4">
            {filteredPopularData.map((val, inx) => (
              <Col xl={3} lg={3} md={6} sm={12} key={inx}>
                <PopularCard val={val} />
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    );
  }

  const ExploringSection = () => {
    return (
      <section className="exploring-section" id="exploring-section">
        <Container>
          <div className="packages-header">
            <h2>Exploring Made Easy</h2>
            <p>Discover the perfect safari experience for your adventure</p>
          </div>
          <Features />
        </Container>
      </section>
    );
  };

  return (
    <>
      <Banner />
      <PackagesSection />
      <SafariSection />
      <ExploringSection />

      {/* Hotel Booking Modal */}
      <Modal 
        show={showHotelModal} 
        onHide={() => setShowHotelModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Hotel Booking</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <HotelBookingForm />
        </Modal.Body>
      </Modal>

      <section className="call_us">
        <Container>
          <Row className="align-items-center">
            <Col md="8">
              <h5 className="title">CALL TO ACTION</h5>
              <h2 className="heading">
                READY FOR UNFORGATABLE TRAVEL. REMEMBER US!
              </h2>
              <p className="text text-">
                Discover the wild with Corbett Aura! Venture into lush forests, spot majestic Bengal tigers, and feel the thrill of an open jeep safari. Our exclusive packages blend adventure, comfort, and nature—right in India's first national park.
              </p>
            </Col>
            <Col md="4" className="text-center mt-3 mt-md-0">
              <Link to="/contact" className="secondary_btn bounce">
                Contact Us !
              </Link>
            </Col>
          </Row>
        </Container>
        <div className="overlay"></div>
      </section>
    </>
  );
};

export default Home;
